import { useRef, useState, useEffect, useCallback, memo } from "react";
import { sendTouchlineRequest } from "../apis/web_socket";
import { AutoSizer, List } from "react-virtualized";
import { handleVisibleSCripsUnSubscription } from "../utils/global_functions";
import { updateObjVisibleScrips } from "../redux/actions/scripInfo";
import { useDispatch } from "react-redux";
const CustomVirtualizer = ({
    data = [],
    itemHeight = 60,
    renderItem,
    segmentId,
    token
}) => {
    const dispatch = useDispatch();
    const [objScripsRequest, setObjScripsRequest] = useState({});
    const listRef = useRef(null);
    const [visibleItems, setVisibleItems] = useState([]);

    const handleScripsSubsscriptionAndUnsubscription = useCallback((subarr) => {
        let arrVisibleIndices = subarr;
        setObjScripsRequest(prevState => {
            let objpreviosScripsCopy = prevState;
            let arrWithKeys = [];
            let subscribeScrips = []; // This array is a non repeated subscrips for subscription
            let unSubScribeScrips = []; // this array is scrips of unsubscription]

            const arrVisibleRows = arrVisibleIndices.map(item => {
                let id = item[segmentId] + '_' + item[token];
                arrWithKeys?.push(id);
                if (!objpreviosScripsCopy[id]) {
                    objpreviosScripsCopy[id] = true;
                    subscribeScrips?.push({ exchangeId: item[segmentId], token: item[token], isSubscribe: true });

                }
                return { exchangeId: item[segmentId], token: item[token], isSubscribe: true };
            });
            Object?.keys(objpreviosScripsCopy)?.forEach(key => {
                if (!arrWithKeys.includes(key)) {
                    let obj = {
                        exchangeId: Number(key?.split('_')[0]),
                        token: Number(key?.split('_')[1]),
                        isSubscribe: false
                    };
                    unSubScribeScrips?.push(obj);
                    delete objpreviosScripsCopy[key];
                }
            });
            sendTouchlineRequest(unSubScribeScrips);
            sendTouchlineRequest(subscribeScrips);
            dispatch(updateObjVisibleScrips({ ...objpreviosScripsCopy }));
            return { ...objpreviosScripsCopy };
        });
    }, [segmentId, token, dispatch]);

    useEffect(() => {
        handleScripsSubsscriptionAndUnsubscription(visibleItems);
    }, [handleScripsSubsscriptionAndUnsubscription, visibleItems]);

    const onRowsRendered = useCallback(({ startIndex, stopIndex }) => {
        const visibleItems = data.slice(startIndex, stopIndex + 1);
        setVisibleItems(visibleItems);
    }, [data]);
    //Ameersha N - Unsubscribing scrips on unmounting of componenet 
    const handleUnsubcription = () => {
        handleVisibleSCripsUnSubscription();
    };
    //Ameersha N - Unsubscribing scrips on unmounting of componenet 

    //Ameersha N - Unsubscribing scrips on unmounting of componenet 
    useEffect(() => {
        return () => {
            handleUnsubcription();
        };
    }, []);
    //Ameersha N - Unsubscribing scrips on unmounting of componenet 
    const rowRenderer = ({ index, style }) => {
        const item = data[index];
        if (!item) return null;
        return renderItem({ index, data, style });
    };

    return (
        <AutoSizer>
            {({ height, width }) => (
                <List
                    ref={listRef}
                    height={height}
                    width={width}
                    rowHeight={itemHeight}
                    rowCount={data.length}
                    rowRenderer={rowRenderer}
                    onRowsRendered={onRowsRendered}
                    overscanRowCount={5}
                />
            )}
        </AutoSizer>
    );
};

export default memo(CustomVirtualizer);
